import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';

const Section = styled('section')({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingRight: '4px'
});

export function ImageCommentsSkeleton() {
    return (
        <Section
            aria-labelledby="image-comments-skeleton-heading"
            aria-busy="true"
            data-testid="image-comments-skeleton"
        >
            <Typography
                id="image-comments-skeleton-heading"
                variant="h3"
                sx={{ fontSize: '22px', fontWeight: 400 }}
            >
                {Translate('image-processing/modal/comments/header-label/comments')}
            </Typography>
            <Skeleton variant="rectangular" animation="wave" height={88} aria-hidden="true" />
            <Skeleton variant="rectangular" animation="wave" height={120} aria-hidden="true" />
        </Section>
    );
}
